///
/// EarthBrowser
///
/// Created by Matt Giger on 8/29/2024
/// Copyright (c) 2024 Geodata Labs
///

import { Database } from "../Database";

type CacheEntryRow = {
	data: Uint8Array
}

export class CacheTable {

	public static initialize(db: Database) {
		db.enqueue([
			{ sql: "create table if not exists cache (url text primary key, expires integer, data blob, size integer)" },
			{ sql: "create index if not exists cache_url_expires on cache (url, expires)" },
		], "critical")
	}

	public static async cacheSize(): Promise<number> {
		if(Database.cacheAvailable) {
			const rows = await Database.db.exec("select sum(size) from cache", [], "high") as { "sum(size)": number }[]
			return rows[0]["sum(size)"] ?? 0
		}
		return -1
	}

	public static async get(url: string): Promise<ArrayBuffer | undefined> {
		if(Database.cacheAvailable) {
			const rows = await Database.db.exec("select data from cache where url = ? and expires > ?", [url, Date.now()], "high") as CacheEntryRow[]
			if(rows.length > 0) {
				return rows[0].data.buffer as ArrayBuffer
			}
		}
		return undefined
	}

	public static set(url: string, expires: number, data: ArrayBuffer): void {
		if(Database.cacheAvailable) {
			const statement = `INSERT INTO cache (url, expires, data, size) VALUES (?, ?, ?, ?)
				ON CONFLICT(url) DO UPDATE SET expires = excluded.expires, data = excluded.data, size = excluded.size`
			Database.db.enqueue([{ sql: statement, params: [url, expires, new Uint8Array(data), data.byteLength] }], "low")
		}
	}

	public static remove(url: string): void {
		if(Database.cacheAvailable) {
			const statement = "delete from cache where url = ?"
			Database.db.enqueue([{ sql: statement, params: [url] }], "low")
		}
	}
	public static purge(): void {
		if(Database.cacheAvailable) {
			const statement = "delete from cache where expires < ?"
			Database.db.enqueue([{ sql: statement, params: [Date.now()] }], "low")
		}
	}
}
